// src/config/toneOfVoiceOptions.js

const toneOfVoiceOptions = [
  { value: "Professional and Formal", label: "Professional and Formal" },
  { value: "Friendly and Casual", label: "Friendly and Casual" },
  { value: "Empathetic and Supportive", label: "Empathetic and Supportive" },
  { value: "Enthusiastic and Energetic", label: "Enthusiastic and Energetic" },
  { value: "Concise and Direct", label: "Concise and Direct" },
  { value: "Humorous and Playful", label: "Humorous and Playful" },
  {
    value: "Educational and Informative",
    label: "Educational and Informative",
  },
  { value: "Youthful and Trendy", label: "Youthful and Trendy" },
  { value: "Calm and Reassuring", label: "Calm and Reassuring" },
  { value: "Neutral and Objective", label: "Neutral and Objective" },
];

export default toneOfVoiceOptions;
